import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/is.ts
var add = "Bæta við";
var remove = "Fjarlægja";
var removeAll = "Fjarlægja allt";
var incomplete = "Því miður, það er ekki búið að fylla rétt inn í alla reiti.";
var submit = "Senda";
var noFiles = "Engin skrá valin";
var moveUp = "Færa upp";
var moveDown = "Færa niður";
var isLoading = "Hleðsla...";
var loadMore = "Sækja meira";
var next = "Áfram";
var prev = "Til baka";
var addAllValues = "Bæta við öllum gildum";
var addSelectedValues = "Bæta við völdum gildum";
var removeAllValues = "Fjarlægja öll gildi";
var removeSelectedValues = "Fjarlægja valin gildi";
var chooseDate = "Velja dagsetningu";
var changeDate = "Breyta dagsetningu";
var close = "Loka";
var open = "Opið";
var accepted = function({
  name
}) {
  return `Vinsamlegast samþykktu ${name}`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} þarf að vera eftir ${date(args[0])}.`;
  }
  return `${sentence(name)} þarf að vera í framtíðinni.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} má einungis innihalda bókstafi.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} má einungis innihalda bókstafi og tölur.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} má einungis innihalda bókstafi og bil.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} verður að innihalda bókstafi.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} verður að innihalda bókstafi eða tölur.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} verður að innihalda bókstafi eða bil.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} verður að innihalda tákn.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} verður að innihalda hástaf.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} verður að innihalda lágstaf.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} verður að innihalda tölur.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} verður að vera tákn.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} má einungis innihalda hástafi.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} má einungis innihalda lágstafi.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} þarf að vera á undan ${date(args[0])}.`;
  }
  return `${sentence(name)} þarf að vera liðin.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Þessi reitur var ekki rétt stilltur.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} þarf að vera á milli ${a} og ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} passar ekki.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} er ekki gild dagsetning, vinsamlegast hafið dagsetninguna í formi ${args[0]}`;
  }
  return "Þessi reitur var ekki rétt stilltur";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} þarf að vera á milli ${date(args[0])} og ${date(args[1])}`;
};
var email = "Vinsamlegast sláðu inn gilt netfang.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} endar ekki á ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} er ekki leyfilegt gildi.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} þarf að vera að minnsta kosti einn stafur.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} þarf að vera færri en eða nákvæmlega ${max2} stafir.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} þarf að vera ${max2} stafir að lengd.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} þarf að vera fleiri en eða nákvæmlega ${min2} stafir.`;
  }
  return `${sentence(name)} þarf að vera á milli ${min2} og ${max2} stafir.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} er ekki leyfilegt gildi.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ekki hægt að hafa fleiri en ${args[0]} ${name}.`;
  }
  return `${sentence(name)} þarf að vera minna en eða nákvæmlega ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Ekki leyfileg tegund skráar.";
  }
  return `${sentence(name)} þarf að vera af tegundinni: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Ekki hægt að hafa færri en ${args[0]} ${name}.`;
  }
  return `Þarf að vera að minnsta kosti ${args[0]} ${name}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” er ekki leyfilegt fyrir ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} þarf að vera tala.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" or ")} is required.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} er skilyrt.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} byrjar ekki á ${list(args)}.`;
};
var url = function() {
  return `Vinsamlegast sláðu inn gilda slóð.`;
};
var invalidDate = "Valin dagsetning er ógild";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var is_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, is_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=is.mjs.map